import isTransferable from "@homer.utility/validator.istransferable";

/**
 * Convert a given task into a worker-executable script
 *
 * @param {Function} task
 *
 * @returns {String}
 *
 * @ignore
 */
export default function create(task) {
    return `
        const $task = ${task};
        const $isTransferable = ${isTransferable};

        /*
        new PerformanceObserver((items) => {
                for (const entry of items.getEntries()) {
                    if (entry.initiatorType !== "fetch") {
                        return;
                    }

                    const url = new URL(entry.name);

                    if (url.pathname.indexOf("/fragment/") !== 0 || url.searchParams.get("render[type]") !== "fragment") {
                        return;
                    }

                    const parameter = new URLSearchParams(url.searchParams);
                    url.pathname = url.pathname.substring(9);

                    for (const [key, value] of parameter.entries()) {
                        if (key.indexOf("render[") === 0) {
                            url.searchParams.delete(key);
                        }
                    }

                    console.log("[task]", Math.round(entry.responseStart - entry.startTime), url.href, entry);

                    postMessage(
                        ["ttfb", Math.round(entry.responseStart - entry.startTime), entry.name]
                    );
                }
            }).observe({ type: "resource", buffered: true });
        */

        addEventListener("message", (message) => {
            const [uuid, type, parameter] = message.data || [];

            if (type !== "execute") {
                return;
            }

            let isSettled;

            function resolve(result) {
                if (!isSettled) {
                    isSettled = true;

                    postMessage(
                        [uuid, 2, result],
                        $isTransferable(result) ? [ result ] : []
                    );
                }
            }

            function reject(error) {
                if (!isSettled) {
                    isSettled = true;

                    postMessage([uuid, 1, error]);
                }
            }

            try {
                $task.apply($task, [uuid, resolve, reject].concat(parameter));
            } catch(error) {
                if (!isSettled) {
                    isSettled = true;

                    const type = error.name;
                    const message = error.message.replace(new RegExp("^" + type + "(:\s*)"), "");

                    postMessage([uuid, 0, { type, message }]);
                }
            }
        });
    `;
}
